export const PLATFORM_COLLECTIONS = {
  ORGANIZATIONS: 'organizations',
  ORGANIZATION_PUBLIC_PROFILES: 'organizationPublicProfiles',
  ORGANIZATION_MEMBERS: 'organizationMembers',
  ORGANIZATION_INVITES: 'organizationInvites',
  INSTRUCTOR_PUBLIC_PROFILES: 'instructorPublicProfiles',
  BOOKING_REQUESTS: 'bookingRequests',
  BOOKINGS: 'bookings',
  BOOKING_PAYMENTS: 'bookingPayments',
  CASE_CHANGES: 'caseChanges', // Pass 50A: immutable audit stream for booking-case mutations
  SOURCE_INTAKE: 'sourceIntake', // Pass 64: normalized source/channel intake envelopes (front door → BookingCase)

  SERVICES: 'services',
  SERVICE_PACKAGES: 'servicePackages',
  CUSTOMER_MEMBERSHIPS: 'customerMemberships',
  PACKAGE_USAGES: 'packageUsages',
  CLIENT_PROFILES: 'clientProfiles',
  CLIENT_NOTES: 'clientNotes',
  // Pass 85: canonical PARTICIPANT identity (the coached human) — DISTINCT from clientProfiles (staff CRM). Org-scoped,
  // durable participantId, optional Auth link. Plus explicit client↔participant and lesson↔participant relations.
  PARTICIPANT_PROFILES: 'participantProfiles',
  CLIENT_PARTICIPANT_LINKS: 'clientParticipantLinks',
  LESSON_PARTICIPANT_LINKS: 'lessonParticipantLinks',
  PARTICIPANT_INVITES: 'participantInvites',
  // Pass 85.1A: SAFE STUDENT-FACING LESSON PROJECTION (publication/output, NOT source truth). The canonical
  // `lessonInstances` doc stays the source; an EXPLICIT operator/instructor publish copies ONLY approved safe
  // fields into a per-participant projection (`org::lessonId::participantId`) the linked participant may read.
  LESSON_PROJECTIONS: 'lessonProjections',
  RETENTION_ACTIONS: 'retentionActions',
  RETENTION_MESSAGE_TEMPLATES: 'retentionMessageTemplates',
  CALENDAR_CONNECTIONS: 'calendarConnections',
  // Pass 88 — external-calendar projection lineage (server-written) + server-only OAuth token store.
  CALENDAR_PROJECTIONS: 'calendarProjections',
  CALENDAR_INTEGRATION_TOKENS: 'calendarIntegrationTokens',
  AVAILABILITY_SLOTS: 'availabilitySlots',
  // Scheduling pilot (Pass 42): bookings remain the canonical schedule.
  // scheduleChanges is an append-only audit log of material schedule edits.
  // scheduleImports records provenance + idempotent-import sync status.
  SCHEDULE_CHANGES: 'scheduleChanges',
  SCHEDULE_IMPORTS: 'scheduleImports',
  NOTIFICATIONS: 'notifications',
  SUBSCRIPTION_PLANS: 'subscriptionPlans',
  ORGANIZATION_SUBSCRIPTIONS: 'organizationSubscriptions',
  CONTENT_PACKS: 'contentPacks',
  ENTITLEMENTS: 'entitlements',
  LESSON_ASSIGNMENTS: 'lessonAssignments',
};

export const PLATFORM_ROLES = {
  PLATFORM_SUPER_ADMIN: 'platform_super_admin',
  PLATFORM_CONTENT_ADMIN: 'platform_content_admin',
  ORGANIZATION_OWNER: 'organization_owner',
  ORGANIZATION_ADMIN: 'organization_admin',
  // Pass 57C-close (item 1): explicit operational role. Ops runs the day-to-day school (schedule,
  // bookings, assign, cancel, publish-early, sync) WITHOUT gaining owner/admin security/billing/role
  // administration. NOT the ambiguous legacy 'organization' alias.
  ORGANIZATION_OPS: 'ops',
  ORGANIZATION: 'organization',
  INSTRUCTOR: 'instructor',
  STUDENT: 'student',
};

export const CONTENT_OWNER_TYPES = {
  PLATFORM: 'platform',
  ORGANIZATION: 'organization',
  INSTRUCTOR: 'instructor',
};

export const CONTENT_VISIBILITY = {
  PRIVATE: 'private',
  ORGANIZATION: 'organization',
  ASSIGNED_ONLY: 'assigned_only',
  PLATFORM: 'platform',
};

export const ACCESS_TIERS = {
  FREE: 'free',
  ORGANIZATION_INCLUDED: 'organization_included',
  PREMIUM: 'premium',
  ENTERPRISE: 'enterprise',
};
